import {
  IWorkflowsCustomFilter,
  IWorkflowsCustomFilterInput,
  IWorkflowsFilter,
} from '~/client/graph'

import Company from '../models/Company'
import LocationBase from '../models/LocationObjects/LocationBase'
import User from '../models/User'
import WorkflowCategory from '../models/WorkflowCategory'
import WorkflowType from '../models/WorkflowType'

export type FilterValue =
  | string
  | Company
  | User
  | WorkflowType
  | LocationBase<any>
  | WorkflowCategory

export default class CustomWorkflowsFilter implements IWorkflowsCustomFilter {
  public static fromDto(dto: IWorkflowsCustomFilter) {
    const filtersByFilterType = dto.filtersByFilterType.map(
      ({ type, values }) => ({
        type,
        values: values || [],
      }),
    )

    return new CustomWorkflowsFilter(
      dto.id,
      dto.name,
      dto.isPublic,
      dto.projectId,
      dto.userId,
      dto.defaultForUsers,
      filtersByFilterType,
      dto.groupBy,
    )
  }

  public constructor(
    public id: string,
    public name: string,
    public isPublic: boolean,
    public readonly projectId: string,
    public readonly userId: string,
    public readonly defaultForUsers: string[],
    public readonly filtersByFilterType: IWorkflowsFilter[] = [],
    public readonly groupBy: string,
  ) {}

  public toInput(): IWorkflowsCustomFilterInput {
    return this
  }
}
